import { createApp, watch } from "vue"; // Import watch
import App from "./App.vue";
import router from "./router";
import Lara from '@primeuix/themes/lara';
import "./assets/css/nucleo-icons.css"; //
import "./assets/css/nucleo-svg.css"; //
import "./assets/scss/calid2.scss"; // Custom dark theme
import ArgonDashboard from "./argon-dashboard"; //
import { createPinia } from 'pinia';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import PrimeVue from 'primevue/config';
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";

import { useSettingStore } from "@/store/SettingsStore";
import { motion } from "@/plugins/motion";

// PrimeVue components for global registration
import Toast from 'primevue/toast';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Skeleton from 'primevue/skeleton';
import Tooltip from 'primevue/tooltip';

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
pinia.use(piniaPluginPersistedState); //
app.use(router);
app.use(ArgonDashboard);
app.use(PrimeVue, {
    theme: {
        preset: Lara,
        options: {
            darkModeSelector: '.dark-theme'
        },
    },
    ripple: true
}); //
app.use(ToastService);
app.use(ConfirmationService);
app.use(motion);

// Global components
app.component('Toast', Toast);
app.component('DialogView', Dialog);
app.component('InputText', InputText);
app.component('Skeleton', Skeleton);
app.directive('tooltip', Tooltip);

// --- NEW THEME SWITCHING LOGIC ---
// This code must run after app.use(pinia)
const settingsStore = useSettingStore(pinia);

watch(
    () => settingsStore.isDarkMode,
    (isDark) => {
        // 2. Switch Bootstrap Theme
        document.documentElement.setAttribute('data-bs-theme', isDark ? 'dark' : 'light');

        // 3. Toggle Argon's top-level dark mode class (if its CSS relies on it)
        if (isDark) {
            document.body.classList.add('dark-version');
        } else {
            document.body.classList.remove('dark-version');
        }
    },
    { immediate: true } // Run on startup
);
// --- END NEW LOGIC ---

app.mount("#app");